import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateOrder } from "src/modules/order/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createOrder } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createOrder(values);
        router.push("/order");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateOrder)(Create);
